export default function getMainDomain() {
	const hostname = window.location.hostname;
	const domainParts = hostname.split('.');

	if (domainParts.length > 2) {
		return domainParts.slice(1).join('.');
	}

	return hostname;
}
